import MojitoCore from 'mojito/core';
const UIPage = MojitoCore.Presentation.UIPage;
import RaceMeetingPageImpl from './race-meeting-page.js';

/**
 * @namespace RaceMeetingPage
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * Page displaying meeting page for a specific racing sport.
 *
 * @class RaceMeetingPage
 * @extends Mojito.Core.Presentation.UIPage
 * @memberof Mojito.Applications.Sports.Pages.RaceMeetingPage
 */

export default UIPage('RaceMeetingPage', RaceMeetingPageImpl);
